export const iconFontAwesomeArrowsArrowUp19 = (
	<i className="fa-solid fa-arrow-up-1-9"></i>
);
